const PING_SYS_CONFIG_URL = `${process.env.REACT_APP_PING_ORIGIN_URL}/ping-admin/system-config`

const PingSysConfigApiUrls = {
    GET: `${PING_SYS_CONFIG_URL}/get`,
    PUT: `${PING_SYS_CONFIG_URL}/update`
}

export default PingSysConfigApiUrls
